import { useState, useEffect } from 'react';
import useDomElement from 'hooks/useDomElement';

const useExternalBanner = () => {
  const [bannerHeight, setBannerHeight] = useState(0);
  const floatingBanner = useDomElement('.CampaignType--floating');

  const checkIsBottom = (style) => !!style && style.substr(0, style.startsWith('-') ? 2 : 1) <= 0;

  useEffect(() => {
    if (floatingBanner) {
      const isBottom = checkIsBottom(floatingBanner?.style?.bottom);

      if (!isBottom) {
        const height = floatingBanner?.clientHeight;
        setBannerHeight(height);
        return;
      }
    }

    document.addEventListener('om.Campaign.afterShow', (event) => {
      const campaign = event?.detail?.Campaign;
      if (campaign.Types?.type === 'floating') {
        // banner comes from and sticks to bottom
        const isBottom = checkIsBottom(campaign.contain?.style?.bottom);

        // banner sticks to top
        if (!isBottom) {
          const height = campaign.contain?.clientHeight;
          setBannerHeight(height);
          return;
        }

        campaign.contain.style.zIndex = 'var(--z-optinmonster-bottom-left-banner)';

        const hasMobileToolboxSubnav = document.getElementById('mobile-toolbox-subnav');
        if (hasMobileToolboxSubnav) {
          hasMobileToolboxSubnav.style.bottom = `${campaign.contain.offsetHeight + 20}px`;
        }
      }

      if (campaign.Types?.type === 'slide') {
        const hasToolboxSubnav = document.getElementById('toolbox-subnav');

        if (!hasToolboxSubnav) return;

        const currentCampaignStyles = campaign.contain.getAttribute('style');

        campaign.contain.setAttribute(
          'style',
          `${currentCampaignStyles} margin-left: ${
            hasToolboxSubnav.classList.contains('open') || window?.innerWidth <= 1199
              ? '250px'
              : '90px'
          } !important;`,
        );
        campaign.contain.style.zIndex = 'var(--z-optinmonster-bottom-left-banner)';

        campaign.contain.classList.add('sliding-om-promo');
      }
    });

    document.addEventListener('om.Campaign.afterClose', (event) => {
      const campaign = event?.detail?.Campaign;
      const isBottom = checkIsBottom(campaign.contain?.style?.bottom);
      if (campaign.Types?.type === 'floating' && isBottom) {
        const hasMobileToolboxSubnav = document.getElementById('mobile-toolbox-subnav');
        if (hasMobileToolboxSubnav) hasMobileToolboxSubnav.style.bottom = '20px';
      }
    });
  }, [floatingBanner]);

  return bannerHeight;
};

export default useExternalBanner;
